import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import PrestationPage from "@/pages/PrestationPage";
import AdsLandingPage from "@/pages/AdsLandingPage";
import DepartmentLandingPage from "@/pages/DepartmentLandingPage";
import BlogList from "@/pages/BlogList";
import BlogArticle from "@/pages/BlogArticle";
import { DEPT_ROUTES } from "@/lib/departments";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/plombier-charente" element={<AdsLandingPage metier="plomberie" />} />
            <Route path="/serrurier-charente" element={<AdsLandingPage metier="serrurerie" />} />
            <Route path="/electricien-charente" element={<AdsLandingPage metier="electricite" />} />
            {DEPT_ROUTES.map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={<DepartmentLandingPage metier={r.metier} deptSlug={r.deptSlug} />}
              />
            ))}
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/:category" element={<CategoryPage />} />
            <Route path="/:category/:slug" element={<PrestationPage />} />
          </Routes>
          <Footer />
          <StickyCTA />
          <WhatsAppButton />
        </SmoothScroll>
        <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: "12px" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
